import shallowCopyArray from 'utils/arrays/shallowCopyArray.util';
import logger from 'utils/logger.util';
import isMissing from 'utils/predicates/any/isMissing.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const L = logger('moveArrayElement');

const moveArrayElement = (options) => {
  //
  const array = options?.array;
  const index = options?.index;

  const isMoveByValid = Number.isSafeInteger(options?.moveBy);
  const isMoveByMissing = isMissing(options?.moveBy);

  if (!isMoveByMissing && !isMoveByValid) L.warn('()', 'Invalid moveBy:', options?.moveBy, 'for array:', array);

  const moveBy = isMoveByMissing ? -1 : isMoveByValid ? options?.moveBy : 0;

  // check edge cases, return array any way, even empty
  if (!isFullArray(array)) return [];
  if (!(index > 0)) return array;
  if (index > array.length - 1) {
    L.warn('()', 'Invalid index:', index, 'for array:', array);
    return array;
  }

  if (index + moveBy < 0 || index + moveBy > array.length - 1) {
    L.warn('()', 'Move is out of bounds:', { index, moveBy, array }, 'for options:', options);
    return array;
  }

  const copy = shallowCopyArray(array);
  const temp = copy[index]; // save the current row to a variable
  copy[index] = copy[index - moveBy]; // move the prev row to the current row
  copy[index - moveBy] = temp; // add the saved row in place of the previous row

  return copy;
};

export default moveArrayElement;
